/**
 * @param input The array to be shuffled
 * @param exclude Function that returns true if an item should not be shuffled
 * @returns The shuffled array
 */
export default function shuffleArray(input = [], exclude) {
  const array = Array.from(input);
  for (let i = array.length - 1; i > 0; i--) {
    if (exclude === null || exclude === void 0 ? void 0 : exclude(array[i])) continue;
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}